module.exports = __webpack_public_path__ + "img/BDCIcon1.dd009d99.png";